<template>
    <div style="display:flex;gap:10px">
        
        <CButton  color="primary" @click="Print()">Print</CButton>
        <CButton  color="primary" @click="PDF()">PDf</CButton>
        <CButton  color="primary" @click="Excel()">Excel</CButton>
        <CButton  color="primary" @click="Word()">WORD</CButton>
            <div id="Report" v-show="false">
                
                <div style="display:flex">
                    <img src="/images/logo.png" style=" width:100px;margin:10px auto" alt="">
                </div>
                <h1 style="font-family:Arial;text-align:center">سامانه مدیریت  حمل و نقل مسافر درون شهری شیراز</h1>
                <div style="display:flex;direction:rtl" v-if="title!==''">
                    <div style="width:100%;max-width:150px;">
                        <h3 style="font-weight:bold;font-size:20px">عنوان گزارش:</h3>
                    </div>
                    <h3 style="width:100%;text-align:right;color:gray;font-size:20px" v-text="title">
                        
                    </h3>
                </div>
                <div style="display:flex;direction:rtl;margin-top:10px;" v-if="fleet!==''">
                    <div style="width:100%;max-width:150px;">
                        <h3 style="font-weight:bold;font-size:20px">خط:</h3>
                    </div>
                    <h3 style="width:100%;text-align:right;color:gray;font-size:20px" v-text="fleet">
                        
                    </h3>
                </div>
                <div style="display:flex;direction:rtl;margin-top:10px;" v-if="device!==''">
                    <div style="width:100%;max-width:150px;">
                        <h3 style="font-weight:bold;font-size:20px">اتوبوس:</h3>
                    </div>
                    <h3 style="width:100%;text-align:right;color:gray;font-size:20px" v-text="device">
                        
                    </h3>
                </div>
                <div style="display:flex;margin-top:10px;direction:rtl;" v-if="From!==''">
                    <div style="width:100%;max-width:150px;font-size:20px">
                        <h3 style="font-weight:bold">از تاریخ:</h3>
                    </div>
                    <h3 style="width:100%;text-align:right;color:gray;font-size:20px" v-text="From">
                        
                    </h3>
                </div>
                <div style="display:flex;margin-top:10px;direction:rtl;" v-if="TO!==''">
                    <div style="width:100%;max-width:150px;font-size:20px">
                        <h3 style="font-weight:bold">تا تاریخ:</h3>
                    </div>
                    <h3 style="width:100%;text-align:right;color:gray;font-size:20px" v-text="TO">
                        
                    </h3>
                </div>
                <CDataTable

                        :border="true"
                        
                        :striped="true"
                        :small="true"
                        :items="data"
                        :fields="GetFields(data)"
                        :fixed="true"
                        :noItemsView="{ noResults: 'چیزی یافت نشد.', noItems: 'چیزی برای نمایش وجود ندارد.' }"

                    >
                        <template #Rows="{item,index}">
                            <td >
                                {{index+1}}
                            </td>
                        </template>
                        <slot></slot>
                </CDataTable>
            </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import Print from 'vue-print-nb'
    Vue.use(Print);
export default {
    props:{
        data:{
            require:true
        },
        fields:{
            require:true
        },
        label:{
            default:''
        },
        title:{
            default:''
        },
        fleet:{
            default:''
        },
        device:{
            default:''
        },
        From:{
            default:''
        },
        TO:{
            default:''
        },
        
    },
    data(){
        return {
            UserID:1023,
        }
    },
    mounted(){
        if(this.$session.has("User")){
           this.UserID=(this.$session.get("User")).UserID;
        }
    },
    methods:{
        Print(){
            //http://api.tfms.ir/Report/word/download?UserID=1
            this.$htmlToPaper('Report');
        },
        Word(){
            var that=this;
            this.axios
            .post("http://api.tfms.ir/Report/word/generate/new",
            {
                UserID:this.UserID,
                Data1:this.data,
                fields:this.fields,
            } 
            /*, { withCredentials: true }*/)
            .then(response => {
                var data=response.data;
                console.log(data)
                if(data.Status){
                    this.$store.commit('ShowToast',{type:'success',message:'Successfully!.'});
                    window.open("http://api.tfms.ir/Report/word/download?UserID="+that.UserID, "_blank")
                }
                else {
                 this.$store.commit('ShowToast',{type:'error',message:'عملیات با شکست مواجه شد.'});
                }


            })
            .catch(function (error) { 
                console.log(error)
            
            })
        .finally(() =>{
          
        });
        },
        Excel(){
            var that=this;
            this.axios
            .post("http://api.tfms.ir/Report/excel/generate",
            {
                UserID:this.UserID,
                Data1:this.data,
                fields:this.fields,
            } 
            /*, { withCredentials: true }*/)
            .then(response => {
                var data=response.data;
                console.log(data)
                if(data.Status){
                    this.$store.commit('ShowToast',{type:'success',message:'Successfully!.'});
                    window.open("http://api.tfms.ir/Report/excel/download?UserID="+that.UserID, "_blank")
                }
                else {
                 this.$store.commit('ShowToast',{type:'error',message:'عملیات با شکست مواجه شد.'});
                }


            })
            .catch(function (error) { 
                console.log(error)
            
            })
        .finally(() =>{
          
        });
        },
        PDF(){
            var that=this;
            this.axios
            .post("http://api.tfms.ir/Report/pdf/generate",
            {
                UserID:this.UserID,
                Data1:this.data,
                fields:this.fields,
            } 
            /*, { withCredentials: true }*/)
            .then(response => {
                var data=response.data;
                console.log(data)
                if(data.Status){
                    this.$store.commit('ShowToast',{type:'success',message:'Successfully!.'});
                    window.open("http://api.tfms.ir/Report/pdf/download?UserID="+that.UserID, "_blank")
                }
                else {
                 this.$store.commit('ShowToast',{type:'error',message:'عملیات با شکست مواجه شد.'});
                }


            })
            .catch(function (error) { 
                console.log(error)
            
            })
        .finally(() =>{
          
        });
        },
        GetFields(){
            var fields=[];
            Object.entries(this.$store.state.Loading).forEach(entry=>{
                const [key]=entry;
                fields.push({key:key,label:key})
            });
        }
    }
}
</script>

<style>

</style>